import React, { Fragment, useState, useEffect } from 'react';

import { DisplayComponent } from 'formlabs-web-components/BaseComponents';
import { Button } from 'formlabs-web-components/Link';
import CenterModal from '../modal/CenterModal';

const getOpenEventName = id => `openModal_${id}`;

const ModalButton = ({ color, arrow, onClick, label, modalId, type }) => {
  const handleClick = e => {
    if (onClick) {
      onClick(e);
    }
    if (modalId) {
      window.dispatchEvent(new Event(getOpenEventName(modalId)));
    }
  };

  return (
    <Button
      type="button"
      color={type === 'link' ? 'inherit-color' : color}
      arrow={arrow}
      onClick={handleClick}
      styles={{ textAlign: type === 'link' ? 'left' : 'center' }}
    >
      {label}
    </Button>
  );
};

const Modal = ({
  id,
  label,
  type,
  color,
  arrow,
  width,
  children,
  modalId,
  openModalCallback
}) => {
  const [isOpen, setOpen] = useState(false);
  const openEventName = modalId ? getOpenEventName(modalId) : null;

  const openModal = e => {
    setOpen(true);
    if (openModalCallback) {
      openModalCallback();
    }
  };
  const closeModal = e => {
    setOpen(false);
  };

  useEffect(() => {
    if (openEventName) {
      window.addEventListener(openEventName, openModal);
    }
    window.addEventListener('closeModal', closeModal);

    return () => {
      if (openEventName) {
        window.removeEventListener(openEventName, openModal);
      }
      window.removeEventListener('closeModal', closeModal);
    };
  }, []);

  return (
    <Fragment>
      <ModalButton
        type={type}
        color={color}
        arrow={arrow}
        onClick={openModal}
        label={label}
      />
      {isOpen && (
        <CenterModal id={id} onClose={closeModal} width={width}>
          {children}
        </CenterModal>
      )}
    </Fragment>
  );
};

const ModalOpener = DisplayComponent(ModalButton);
export { ModalOpener };

export default DisplayComponent(Modal);
